import { useStrings } from "@1js/localization-components";
import { Column, Row } from "@1js/pl-card-components";
import { Button } from "@fluentui/react-components";
import * as React from "react";
import { ShowMoreButtonLabel } from "./AllPrompts.web.string";
import { useStyles } from "./AllPrompts.web.styles";

export type ShowMoreProps = {
  isShowHasMore: boolean;
  hasMore?: boolean;
  isLoading: boolean;
  handleCardFocus: () => void;
  onMoreClicked: () => void;
};

export const ShowMore = ({
  isShowHasMore,
  hasMore,
  isLoading,
  handleCardFocus,
  onMoreClicked,
}: ShowMoreProps) => {
  const styles = useStyles();
  const localizations = useStrings({
    ShowMoreButtonLabel,
  });

  const handleOnClick = React.useCallback(() => {
    handleCardFocus();
    onMoreClicked();
  }, [handleCardFocus, onMoreClicked]);

  if (!isShowHasMore || !hasMore) {
    return <></>;
  }

  return (
    <Row className={styles.footerRow}>
      <div data-testid="show-more-button-row-wrap"></div>
      <Column size="auto">
        <div data-testid="show-more-button-column-wrap"></div>
        <Button
          size="large"
          disabled={isLoading}
          onClick={handleOnClick}
          data-testid="show-more-button"
          className={styles.moreButton}
        >
          {localizations.ShowMoreButtonLabel()}
        </Button>
      </Column>
    </Row>
  );
};
